import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export function Button({
  children,
  onClick,
  className = '',
  href
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-dark transition-all duration-300 bg-gradient-to-r from-gold-400 to-gold-600 rounded-sm overflow-hidden group hover:shadow-[0_0_25px_rgba(201,168,76,0.6)]';
  const content = <>
      <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-gold-300 to-gold-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-out" data-id="element-220"></span>
      <span className="relative flex items-center gap-2" data-id="element-221">{children}</span>
    </>;
  if (href) {
    return <motion.a href={href} onClick={onClick} className={`${baseStyles} ${className}`} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-222">
        {content}
      </motion.a>;
  }
  return <motion.button onClick={onClick} className={`${baseStyles} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-223">
      {content}
    </motion.button>;
}